export default __webpack_public_path__ + "static/media/Better_IoT_with_Serverless_GraphQL_GraphQL_Asia.0b1e3567.jpg";